<template>
	<div class="mb-4">
	   <file-upload @upload="prepareToUpload"></file-upload>
	</div>
</template>

<script>
    export default {
        data(){
            return {
                files: []
            }
        }, 
        methods: {
            prepareToUpload(files){
                this.files = files;
                for(let i=0; i<this.files.length; i++){
                    let formData = new FormData();
                    formData.append('file', this.files[i]);
                    formData.append('name', this.files[i].nome);
                    formData.append('produto_id', this.$route.params.id);
                    this.upload(formData);
                }
            },
            upload(dados){
            	var config = {
					position: 'bottom-right',
				};
                axios.post(
                    this.$url+'/api/adm/produto-imagens/store', 
                    dados,
                    {
                        headers: {
                            'Content-Type': 'multipart/form-data'
                        }
                    }
                )
                .then(response => {
                    this.$bshMessage.show(response.data.message, response.data.type, config)
                    this.$emit('reload')
                })
                .catch(error => {
                    console.log('deu erro');
                });
            }
        }
    }
</script>